module.exports = __webpack_public_path__ + "img/page_desarrolla_slider3.8244f458.png";